//const urlBase = 'http://localhost:63562/api/restful/'
const urlBase = 'https://apps1.contraloria.gob.pe/veeduriasaju/back/api/restful/'
//const urlBase = 'https://serverqa1.contraloria.gob.pe/veeduria/back/api/restful/'
//const urlBase = 'https://apptest27.contraloria.gob.pe/servicioveeduria/api/restful/'


const NEXT_PUBLIC_GOOGLE_MAPS_API_KEY = "AIzaSyAi9kcw5WqrKHwu5MkMTEZZl-iSjoqvy-0"
//const NEXT_PUBLIC_GOOGLE_MAPS_API_KEY = "AIzaSyDv_FqlYAibf3K_BSO4-7e9lGlWll4CHys"
const generate_token_url = urlBase + 'padre-familia/generate-token'
const valida_dni_url = urlBase + 'padre-familia/valida-dni'
const valida_dni_private_url = urlBase + 'padre-familia/valida-dni-private'
const get_veeduria_padre_url = urlBase + 'padre-familia/get-veeduria-padre'
const genera_captcha_url = urlBase + 'captcha/genera-captcha'
const region_get_url = urlBase + 'region/region-get-all'
const provincia_get_url = urlBase + 'provincia/provincia-get-all-by-region'
const distrito_get_url = urlBase + 'distrito/distrito-get-all-by-provincia'
const institucion_get_url = urlBase + 'inst-edu/inst-edu-get-all-by-ubigeo'
const pregunta_url = urlBase + 'pregunta/pregunta-get-all'
const veeduria_url = urlBase + 'veeduria/veeduria-insert-all'
const valida_existe_dni_url = urlBase + 'estudiante/valida-dni'
const obtiene_formatos_url = urlBase + 'inst-edu/obtiene-formatos'
const obtiene_formatos_completados_url = urlBase + 'inst-edu/obtiene-formatos-completados'
const formato_get_url = urlBase + 'formato/formato-get-all'
const formato_get_by_nombre_url = urlBase + 'formato/formato-get-by-nombre'
const parametro_get_url = urlBase + 'parametro/parametro-get-all'
const municipalidad_get_url = urlBase + 'municipalidad/municipalidad-get-all-by-ubigeo'
const valida_beneficiario_url = urlBase + 'estudiante/valida-beneficiario'
const download_pdf_url = urlBase + 'veeduria/download-pdf'

//alert(generate_token_url)
//alert(valida_dni_url)
export {
    generate_token_url,
    valida_dni_url,
    valida_dni_private_url,
    get_veeduria_padre_url,
    genera_captcha_url,
    region_get_url,
    provincia_get_url,
    distrito_get_url,
    institucion_get_url,
    pregunta_url,
    veeduria_url,
    valida_existe_dni_url,
    obtiene_formatos_url,
    obtiene_formatos_completados_url,
    formato_get_url,
    formato_get_by_nombre_url,
    parametro_get_url,
    municipalidad_get_url,
    valida_beneficiario_url,
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
    download_pdf_url
}

//alert(formato_get_url)

